import React, { useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronDown, faChevronLeft, faChevronRight, faList, faGrip, faMagnifyingGlass, faFloppyDisk, faBookmark, faTimes, faFilter } from '@fortawesome/free-solid-svg-icons';
import { useSwimmerAPI } from '../context/SwimmerAPIContext';
import SearchHelpCarousel from './SearchHelpCarousel';
const SearchSection = ({ onSwimmerSelect, onSaveSwimmer, savedTirefs, loading, setLoading, showToast }) => {
    const api = useSwimmerAPI();
    const [isCollapsed, setIsCollapsed] = useState(false);
    const [isCompact, setIsCompact] = useState(false);
    const [searchInput, setSearchInput] = useState('');
    const [searchResults, setSearchResults] = useState([]);
    const [currentPage, setCurentPage] = useState(1);
    const [quickFilter, setQuickFilter] = useState('');
    const resultsPerPage = 7;
    const handleSearch = async () => {
        const surname = searchInput.trim();
        if (!surname) {
            showToast('Please enter a surname', 'error');
            return;
        }
        setLoading(true);
        try {
            const results = await api.searchSwimmer(surname);
            setSearchResults(results);
            setCurentPage(1);
            setQuickFilter('');
            if (results.length === 0) {
                showToast('No swimmers found', 'error');
            }
        }
        catch (error) {
            showToast(`Error searching ${error.message}`, 'error');
        }
        finally {
            setLoading(false);
        }
    };
    const handleKeyPress = (e) => {
        if (e.key === 'Enter') {
            handleSearchWrapped();
        }
    };
    const filteredResults = searchResults.filter(swimmer => {
        if (!quickFilter)
            return true;
        const q = quickFilter.toLowerCase();
        return swimmer.name.toLowerCase().includes(q) || swimmer.club.toLowerCase().includes(q);
    });
    const handleQuickFilterChange = (value) => {
        setQuickFilter(value);
        setCurentPage(1);
    };
    // Track if a search has been performed
    const [hasSearched, setHasSearched] = useState(false);
    const handleSearchWrapped = async () => {
        setHasSearched(true);
        await handleSearch();
    };
    const handleTryExample = (surname) => {
        setSearchInput(surname);
        setHasSearched(false);
    };
    const showCarousel = !hasSearched && searchResults.length === 0;
    return (React.createElement("section", { className: `search-section card${showCarousel ? ' search-section-empty' : ''}` },
        React.createElement("div", { className: "section-header" },
            React.createElement("h2", null, "Search for Swimmer"),
            React.createElement("div", { style: { display: 'flex', gap: '0.5rem', alignItems: 'center' } },
                React.createElement("button", { className: "btn-ghost section-toggle", onClick: () => setIsCompact(c => !c), title: isCompact ? 'Switch to comfortable view' : 'Switch to compact view' },
                    React.createElement(FontAwesomeIcon, { icon: isCompact ? faGrip : faList })),
                React.createElement("button", { className: "btn-ghost section-toggle panel-collapse-toggle", onClick: () => setIsCollapsed(c => !c), "aria-label": "Toggle section" },
                    React.createElement(FontAwesomeIcon, { icon: faChevronDown, className: `chevron-icon${!isCollapsed ? ' expanded' : ''}` })))),
        !isCollapsed && React.createElement(React.Fragment, null,
            React.createElement("div", { className: "search-controls" },
                React.createElement("div", { className: "search-input-wrap" },
                    React.createElement("input", { type: 'text', value: searchInput, onChange: (e) => { setSearchInput(e.target.value); if (hasSearched)
                            setHasSearched(false); }, onKeyPress: handleKeyPress, placeholder: "Search by Surname...", disabled: loading }),
                    searchInput.length > 0 && (React.createElement("button", { type: "button", className: "search-filter-clear", onClick: () => { setSearchInput(''); setHasSearched(false); setSearchResults([]); }, title: "Clear search", "aria-label": "Clear search" },
                        React.createElement(FontAwesomeIcon, { icon: faTimes })))),
                React.createElement("button", { onClick: handleSearchWrapped, disabled: loading }, "Search")),
            React.createElement("div", { id: 'searchResults' },
                !hasSearched && searchResults.length === 0 && (React.createElement(SearchHelpCarousel, { onTryExample: handleTryExample })),
                searchResults.length > 0 && (React.createElement("div", { className: "search-results-content" },
                    React.createElement("div", { className: "filter-section" },
                        React.createElement("div", { className: "search-filter-row" },
                            React.createElement("div", { className: "search-filter-input-wrap" },
                                React.createElement(FontAwesomeIcon, { icon: faFilter, className: "search-filter-icon" }),
                                React.createElement("input", { id: "quickFilter", type: "text", value: quickFilter, onChange: (e) => handleQuickFilterChange(e.target.value), placeholder: "Filter by name or club...", disabled: loading, className: "search-filter-input" }),
                                quickFilter.length > 0 && (React.createElement("button", { type: "button", className: "search-filter-clear", onClick: () => handleQuickFilterChange(''), title: "Clear filter", "aria-label": "Clear filter" },
                                    React.createElement(FontAwesomeIcon, { icon: faTimes })))))),
                    React.createElement("div", { className: "pagination-info" },
                        "Showing ",
                        ((currentPage - 1) * resultsPerPage) + 1,
                        " to ",
                        Math.min(currentPage * resultsPerPage, filteredResults.length),
                        " of ",
                        filteredResults.length,
                        " results",
                        quickFilter && `(filtered from ${searchResults.length} total)`),
                    React.createElement("div", { className: isCompact ? undefined : 'search-results-grid' }, filteredResults
                        .slice((currentPage - 1) * resultsPerPage, currentPage * resultsPerPage)
                        .map((swimmer) => {
                        const isSaved = savedTirefs.has(swimmer.tiref);
                        return isCompact ? (React.createElement("div", { key: swimmer.tiref, className: "swimmer-result-compact" },
                            React.createElement("span", { className: "swimmer-result-compact-name" }, swimmer.name),
                            React.createElement("span", { className: "swimmer-result-compact-meta" },
                                swimmer.club,
                                " \u2022 Born ",
                                swimmer.birthYear,
                                " \u2022 ",
                                swimmer.gender),
                            React.createElement("button", { onClick: () => onSwimmerSelect(swimmer.tiref, swimmer.name, swimmer.birthYear, swimmer.gender, swimmer.club), disabled: loading, title: "View Times" },
                                React.createElement(FontAwesomeIcon, { icon: faMagnifyingGlass })),
                            React.createElement("button", { className: `swimmer-result-save${isSaved ? ' is-saved' : ''}`, onClick: () => onSaveSwimmer(swimmer.tiref, swimmer.name, swimmer.birthYear, swimmer.gender, swimmer.club), disabled: loading || isSaved, title: isSaved ? 'Already saved' : 'Save swimmer', "aria-label": isSaved ? 'Already saved' : 'Save swimmer' },
                                React.createElement(FontAwesomeIcon, { icon: isSaved ? faBookmark : faFloppyDisk })))) : (React.createElement("div", { key: swimmer.tiref, className: "swimmer-result" },
                            React.createElement("div", { className: "swimmer-result-header" },
                                React.createElement("h3", null, swimmer.name),
                                React.createElement("div", { className: "swimmer-result-card-actions" },
                                    React.createElement("button", { onClick: () => onSwimmerSelect(swimmer.tiref, swimmer.name, swimmer.birthYear, swimmer.gender, swimmer.club), disabled: loading, className: "btn-view btn-ghost", title: "View times" },
                                        React.createElement(FontAwesomeIcon, { icon: faMagnifyingGlass })),
                                    React.createElement("button", { className: `swimmer-result-save btn-ghost${isSaved ? ' is-saved' : ''}`, onClick: () => onSaveSwimmer(swimmer.tiref, swimmer.name, swimmer.birthYear, swimmer.gender, swimmer.club), disabled: loading || isSaved, title: isSaved ? 'Already saved' : 'Save swimmer', "aria-label": isSaved ? 'Already saved' : 'Save swimmer' },
                                        React.createElement(FontAwesomeIcon, { icon: isSaved ? faBookmark : faFloppyDisk })))),
                            React.createElement("div", { className: "swimmer-result-meta" },
                                React.createElement("span", { className: "swimmer-result-meta-text" },
                                    swimmer.club,
                                    " \u2022 Born ",
                                    swimmer.birthYear,
                                    " \u2022 ",
                                    swimmer.gender))));
                    })),
                    filteredResults.length > resultsPerPage && (React.createElement("div", { className: "pagination" },
                        React.createElement("button", { onClick: () => setCurentPage(prev => Math.max(1, prev - 1)), disabled: currentPage === 1 || loading, className: 'btn-ghost', style: { color: 'var(--primary)' } },
                            React.createElement(FontAwesomeIcon, { icon: faChevronLeft }),
                            " Previous"),
                        React.createElement("span", null,
                            "Page ",
                            currentPage,
                            " of ",
                            Math.ceil(filteredResults.length / resultsPerPage)),
                        React.createElement("button", { onClick: () => setCurentPage(prev => Math.min(Math.ceil(filteredResults.length / resultsPerPage), prev + 1)), disabled: currentPage >= Math.ceil(filteredResults.length / resultsPerPage) || loading, className: 'btn-ghost', style: { color: 'var(--primary)' } },
                            "Next ",
                            React.createElement(FontAwesomeIcon, { icon: faChevronRight })))),
                    filteredResults.length === 0 && (React.createElement("div", { className: "empty-state" },
                        React.createElement("p", null, "No swimmers match the current filters"))))),
                hasSearched && searchResults.length === 0 && (React.createElement("div", { className: "empty-state" },
                    React.createElement("p", null, "No swimmers found")))))));
};
export default SearchSection;
